'use strict';

const MapContentExporter = require('../../models/map-content-exporter'),
	exportResultSendDecorators = require('../../models/export-result-send-decorators'),
	StoryboardExporter = require('../../models/storyboard-exporter'),
	RemoteExportController = require('../../models/remote-export-controller'),
	ExportAjaxResultLoader = require('../../models/export-ajax-result-loader'),
	freemindExport = require('../../models/freemind-export'),
	atlasResultWrapper = require('../../models/atlas-result-wrapper'),
	exportResultDecorators = require('../../models/export-result-decorators'),
	LocalExportController = require('../../models/local-export-controller'),
	buildDecoratedResultProcessor = require('../../models/build-decorated-result-processor'),
	GoldAtlasApi = require('../../models/gold-atlas-api'),
	AtlasModel = require('../../models/atlas-model'),
	MapMetadataModel = require('../../models/map-metadata-model'),
	mmWidgets = require('../../widgets/mm-widgets');

require('../../widgets/local-export-widget');
require('../../widgets/remote-export-widget');
require('../../widgets/atlas-republishing-widget');
require('../../widgets/atlas-prepopulate-widget');
require('../../widgets/dispatched-event-value-widget');
require('../../widgets/context-disabler-widget');


module.exports = function mapExportsStart(config, configurationGenerator, s3Api, activityLog, goldFunnelModel, navigatorShim, collaborationModel, mapModel, themeProvider, iconLocaliser,  assetLocaliser, storyboardModel, storyboardDimensionProvider, ajaxPromise, authentication, goldApi, pageController, nodeViewModel, metadataSynchronizer) {
	if (!config || !configurationGenerator || !s3Api || !activityLog || !goldFunnelModel || !navigatorShim || !collaborationModel || !mapModel || !themeProvider || !iconLocaliser || !assetLocaliser || !storyboardModel || !storyboardDimensionProvider || !ajaxPromise || !authentication || !goldApi || !pageController || !nodeViewModel) {
		throw 'invalid-args';
	}
	const sendPostProcessing = buildDecoratedResultProcessor((response) => {
			return Promise.resolve(response);
		}, exportResultSendDecorators),
		mapContentExporter = new MapContentExporter(assetLocaliser, collaborationModel, mapModel, themeProvider, nodeViewModel),
		mapExporter = { exporter: mapContentExporter.makeExportable, processor: sendPostProcessing },
		signedUrlMapContentExporter = (exportProps, exportConfiguration) => mapContentExporter.makeExportable(exportProps, Object.assign({sendSignedGoldAsserUrls: true}, exportConfiguration)),
		signedUrlMapExporter = { exporter: signedUrlMapContentExporter, processor: sendPostProcessing },
		storyboardExporter = new StoryboardExporter(iconLocaliser,  storyboardModel, storyboardDimensionProvider),
		signedUrlStoryBoardExporter = () => storyboardExporter.makeExportable({sendSignedGoldAsserUrls: true}),
		ajaxResultLoader = new ExportAjaxResultLoader(ajaxPromise),
		goldAtlasApi = new GoldAtlasApi(authentication.authenticationModel, goldApi),
		mapMetadataModel = new MapMetadataModel(pageController, navigatorShim, {metadataSynchronizer: metadataSynchronizer}),
		atlasModel = new AtlasModel(config, collaborationModel, goldAtlasApi, mapMetadataModel),
		sharePostProcessing = buildDecoratedResultProcessor(
			ajaxResultLoader.load,
			atlasResultWrapper(exportResultDecorators, atlasModel)
		),
		layoutExportFormatFunctions = {
			'map.pdf': signedUrlMapExporter,
			'map.svg': mapExporter,
			'map.png': signedUrlMapExporter,
			'map.jpg': signedUrlMapExporter,
			'presentation.pdf': { exporter: signedUrlStoryBoardExporter, processor: sendPostProcessing },
			'presentation.pptx': { exporter: storyboardExporter.makeExportable, processor: sendPostProcessing },
			'storyboard.docx': { exporter: signedUrlStoryBoardExporter, processor: sendPostProcessing },
			'outline.docx': signedUrlMapExporter,
			'outline.md': mapExporter,
			'outline.txt': signedUrlMapExporter,
			'outline.html': mapExporter,
			'outline.org': mapExporter,
			'outline.opml': mapExporter,
			// 'outline.pdf': mapExporter,
			'notes.txt': signedUrlMapExporter,
			'notes.docx': signedUrlMapExporter,
			'notes.html': signedUrlMapExporter,
			// 'notes.pdf': mapExporter,
			'atlas.json': { exporter: signedUrlMapContentExporter, processor: sharePostProcessing}
		},
		layoutExportController = new RemoteExportController(layoutExportFormatFunctions, configurationGenerator, s3Api, goldFunnelModel, navigatorShim),
		localMapContentExporter = new MapContentExporter(assetLocaliser, collaborationModel, mapModel, themeProvider, false, {literalTheme: true}),
		localExportController = new LocalExportController(navigatorShim, localMapContentExporter, freemindExport, mapMetadataModel);



	return {
		initialiseWidgets: () => {
			mmWidgets('[data-mm-role~="localExportWidget"]').localExportWidget(localExportController);
			mmWidgets('[data-mm-role~="layout-exporter"]').remoteExportWidget(layoutExportController, authentication.subscriptionModel);
			mmWidgets('[data-mm-role~="atlas-publisher"]').atlasPrepopulationWidget(atlasModel).atlasRepublishingWidget(atlasModel);
			mmWidgets('[data-mm-atlas-status-context]')
				.dispatchedEventValueWidget(atlasModel, ['atlasStatusContext'], 'mm-atlas-status-context', 'mm-atlas-status-context-attr')
				.contextDisablerWidget(atlasModel, 'atlasStatusContext', 'data-mm-atlas-status-context');

		},
		localMapContentExporter: localMapContentExporter,
		layoutExportController: layoutExportController,
		localExportController: localExportController
	};
};
